import { setI18nLang } from '@yandex-int/i18n';

setI18nLang(__appConfig.lang);
